// import store from '@/state/store'
import isSacrificialMiddleware from '../middleware/isSacrificialMiddleware'

export default [
 
  {
    path: '/',
    name: 'default',
    component: () => import('./views/scholar-ships/scholar-ships'),
  },
  {
    path: '/scholar-ships/application-result',
    name: 'application-result',
    component: () => import('./views/scholar-ships/application-result'),
    // beforeEnter:isSacrificialMiddleware
  },
  {
    path: '/beneficiary/:code(\\d{10})',
    name: 'beneficiary',
    component: () => import('./views/scholar-ships/scholar-ships-by-code'),
    beforeEnter:isSacrificialMiddleware
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },

  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]
